import { GetVerificationTokenFunc } from './Plugins/GetVerificationTokenPlugin';

declare global {
  interface Window {
    $verificationToken: GetVerificationTokenFunc;
  }

  const $verificationToken: GetVerificationTokenFunc;
}

declare module "vue/types/vue" {
  interface Vue {
    readonly $verificationToken: GetVerificationTokenFunc;
  }

  interface VueConstructor {
    $verificationToken: GetVerificationTokenFunc;
  }
}